import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormControl } from '@angular/forms';
import { ClientModel } from '../../../shared/models/client.model';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { CardsCreator } from '../../services/cards/creator';
import { PaymentStepsService } from '../../../payment/services/payment-steps.service';

@Component({
    selector: 'account-cards-create',
    templateUrl: './account.cards.create.component.html',
    encapsulation: ViewEncapsulation.None
})
export class AccountCardsCreateComponent {
    @Input() client: ClientModel;
    @Output() canceled: EventEmitter<null> = new EventEmitter<null>();
    @Output() created: EventEmitter<null> = new EventEmitter<null>();
    @Output() failed: EventEmitter<null> = new EventEmitter<null>();
    @Output() creating: EventEmitter<null> = new EventEmitter<null>();
    firstPaymentMethodId: number | null = null;

    public form: FormGroup = new FormGroup({});

    constructor(
        protected cardsCreator: CardsCreator,
        protected toastr: ToastrService,
        protected translate: TranslateService,
        protected paymentStepsService: PaymentStepsService
    ) {
        this.cardsCreator.created$.subscribe(() => {
            this.translate
                .get('ACCOUNT.CARDS.ADD_SUCCESS_MESSAGE')
                .subscribe((message: string) => {
                    this.form.reset();
                    this.toastr.success(message);
                    this.created.emit();
                });
        });
        this.cardsCreator.failed$.subscribe(() => {
            this.translate
                .get(['ACCOUNT.CARDS.ADD_ERROR_TITLE', 'ACCOUNT.CARDS.ADD_ERROR_MESSAGE'])
                .subscribe(translated => {
                    this.toastr.error(
                        translated['ACCOUNT.CARDS.ADD_ERROR_MESSAGE'],
                        translated['ACCOUNT.CARDS.ADD_ERROR_TITLE']
                    );
                    this.failed.emit();
                });
        });
    }

    ngOnInit() {
        this.paymentStepsService.loadPaymentMethods().subscribe({
          next: (paymentMethods) => {
            const filteredIds = paymentMethods
              .filter(
                (method) =>
                  method.type === "credit card" && method.allow_multiple_cards != true
              )
              .map((method) => method.id);
    
            this.firstPaymentMethodId = filteredIds[0] || null;
            console.log("Primeiro ID do método de pagamento filtrado:", this.firstPaymentMethodId);
          }
        });
      }

    /**
     * Emit cancel event.
     **/
    public cancel() {
        this.canceled.emit();
    }
    /**
     * If form is valid, emit creating event and call card creator.
     **/
    public save() {
        if (!this.form.contains('payment_method_id')) {
            this.form.addControl('payment_method_id', new FormControl(null));
        }
        this.form.get('payment_method_id')!.setValue(this.firstPaymentMethodId);

        if (this.form.valid) {
            this.creating.emit();
            this.cardsCreator.setClient(this.client).create(this.form.value);
        }
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src4078178155/src/src/app/account/cards/create/account.cards.create.component.ts